import React from "react";
import { Typography } from "antd";
import SbModal from "uiCore/SbModal/SbModal";
import {
  TEXT,
  WARNING_MODAL_WIDTH,
  CONDITIONAL_MODAL_WIDTH,
} from "../../GroupSkillsProficiencyV2.constants";
import {
  WARNING_MODAL_OK_BUTTON_PROPS,
  CONDITIONAL_MODAL_CANCEL_BUTTON_PROPS,
} from "./SkillsProficiencyModals.styles";

const { Text } = Typography;

const SkillsProficiencyModals = ({
  showWarning,
  onWarningOk,
  onWarningCancel,
  showConditionalAlert,
  onConditionalAlertClose,
}) => (
  <>
    <SbModal
      open={showWarning}
      title={TEXT.WARNING_TITLE}
      onOk={onWarningOk}
      onCancel={onWarningCancel}
      okText={TEXT.WARNING_OK}
      cancelText={TEXT.WARNING_CANCEL}
      width={WARNING_MODAL_WIDTH}
      okButtonProps={WARNING_MODAL_OK_BUTTON_PROPS}
    >
      <Text>{TEXT.WARNING_BODY}</Text>
    </SbModal>

    <SbModal
      open={showConditionalAlert}
      title={TEXT.CONDITIONAL_ALERT_TITLE}
      onOk={onConditionalAlertClose}
      onCancel={onConditionalAlertClose}
      okText={TEXT.CONDITIONAL_ALERT_OK}
      cancelButtonProps={CONDITIONAL_MODAL_CANCEL_BUTTON_PROPS}
      width={CONDITIONAL_MODAL_WIDTH}
    >
      <Text>{TEXT.CONDITIONAL_ALERT_MSG}</Text>
    </SbModal>
  </>
);

export default SkillsProficiencyModals;
